import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import FormDivider from 'v-c/Forms/FormDivider';

import {
    FormRow,
    FormLabel,
    FormTitle,
} from 'v-c/Forms';

import { LargeCheckbox, StackedCheckboxContainer } from 'v-c/Forms/Checkboxes';

export default function SummaryForm(props) {
    const {
        getKeyedMessage, reportTypes,
    } = props;

    return (
        <div data-field="report-criteria">
            <FormDivider />
            <FormTitle>
                {getKeyedMessage('header.report_criteria')}
            </FormTitle>
            <FormLabel>
                {getKeyedMessage('include')}
            </FormLabel>
            <FormRow>
                <StackedCheckboxContainer>
                    <div className="row" style={{ width: '50%' }}>
                        {reportTypes.map(({ type, onClick, checked, name }) => (
                            <div
                                className="col-xs-6"
                                style={{ paddingBottom: 5 }}
                                key={name}
                            >
                                <LargeCheckbox
                                    data-input={type}
                                    onClick={onClick}
                                    checked={checked}
                                >
                                    {name}
                                </LargeCheckbox>
                            </div>
                        ))}
                    </div>
                </StackedCheckboxContainer>
            </FormRow>
        </div>
    );
}

SummaryForm.displayName = displayName('Reports/report_types/SummaryForm');

SummaryForm.propTypes = {
    getKeyedMessage: PropTypes.func.isRequired,
    reportTypes: PropTypes.array.isRequired,
};
